<script setup>
import { ref, computed } from "vue";
import Loader from "./Loader.vue"
import { useFilteredFeedStore } from "../utils/store.js";

const store = useFilteredFeedStore();
const { endpoint } = store;

const props = defineProps({
	label: {
		type: String,
		required: false,
		default: "Load more",
	},
})

const moreResultsTotal = computed(() => {
	if( store.totalLeft < 100 ){
		return `( ${ store.totalLeft } results)`
	}
})

</script>
<template>
	<footer class="flex justify-center mt-12 -mb-12">
		
		<button 
				class="text-base link" 
				:class="{ 'pointer-events-none': store.isUpdating }" 
				@click="store.nextPage()" 
				v-if="store.page !== store.maxNumPages">
				<span v-if="!store.isUpdating"><span v-html="props.label"></span> {{ moreResultsTotal }}</span>
				<span v-if="store.isUpdating" class="inline-flex gap-2 items-center">
					<span class="underline decoration-1">{{ store.messageLoading }}</span>
					<Loader />
				</span>
			</button>
	</footer>
</template>
